import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Domain } from '@models/domain';
import { AtlasToastService } from '@services/atlas-toast.service';
import { DomainService } from '@services/domain.service';
import { ProfileService } from '@services/profile.service';
import { ToastContainerDirective } from 'ngx-toastr';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
  selector: 'wsb-change-email-component',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ChangeEmailComponent implements OnInit {
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  domain: Domain;
  gologin = false;
  email = null;
  token = null;

  constructor(
    private profileService: ProfileService,
    private router: Router,
    private domainService: DomainService,
    private atlasToastService: AtlasToastService,
    private sessionStorage: SessionStorageService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.domainService.getDomainState().subscribe(x => (this.domain = x));

    this.sessionStorage.store('redirect-after-login', window.location.href);
    this.sessionStorage.store('login-message', 'login_to_confirm');
    this.route.queryParams.subscribe(query => {
      this.token = query.check;
      this.email = query.newemail;

      this.profileService.confirmEmailChange(this.email, this.token).subscribe(
        res => {
          this.sessionStorage.clear('redirect-after-login');
          this.sessionStorage.clear('login-message');
          this.gologin = true;
          this.atlasToastService.success('emailchange_confirmed', null, 60000000, this.toastContainer);
        },
        e => {
          if (e && e.status !== 401) {
            this.sessionStorage.clear('redirect-after-login');
            this.sessionStorage.clear('login-message');
          }
          this.atlasToastService.error('common_error', null, 60000000, this.toastContainer);
        }
      );
    });
  }

  goLogin() {
    this.router.navigate(['/login']);
  }
}
